module.exports = __webpack_public_path__ + "static/img/fly-by-fire-logo-lucre-games.1173cfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/fly-by-fire/fly-by-fire-logo-lucre-games.png
// module id = mFqI
// module chunks = 0